import Vue from 'vue';
import $ from "jquery";
import "tooltipster"
import "tooltipster/dist/css/tooltipster.bundle.min.css"
/*import "tooltipster/dist/css/plugins/tooltipster/sideTip/themes/tooltipster-sideTip-borderless.min.css"
import "tooltipster/dist/css/plugins/tooltipster/sideTip/themes/tooltipster-sideTip-light.min.css"
import "tooltipster/dist/css/plugins/tooltipster/sideTip/themes/tooltipster-sideTip-noir.min.css"
import "tooltipster/dist/css/plugins/tooltipster/sideTip/themes/tooltipster-sideTip-punk.min.css"
import "tooltipster/dist/css/plugins/tooltipster/sideTip/themes/tooltipster-sideTip-shadow.min.css"*/
import "./tooltip.less"
Vue.directive('tooltip', {
    inserted(el, binding, vnode) {
        let self = vnode.context;
        self.$nextTick(() => {
            let $el = $(el);
            let trigger = $el.attr("trigger");
            let title = $el.attr("title");
            let zIndex = $el.attr("zIndex");
            let single = $el.attr("single") == 'false' ? false : true;
            let stop = $el.attr("stop") == "false" ? false : true;
            trigger = trigger ? trigger : 'hover';
            let template = $el.attr("template") == "true";
            let $template;
            let side = $el.attr("side");
            let theme = $el.attr("theme");
            side = side ? side : 'bottom';
            let options = {
                theme: `custom_theme ${theme}`,
                contentCloning: false,
                contentAsHTML: true,
                side: side,
                maxWidth: window.innerWidth - 100,
                zIndex: isNaN(zIndex) ? 99 : zIndex,
                interactive: true,
                trigger: trigger
            };
            if (title) {
                options.content = title;
            } else if (!template) {
                options.content = $el[0].innerHTML;
            } else {
                $template = $el.find(".tooltip_templates>*").eq(0);
                let random = Math.round(Math.random() * 10000);
                let newId = "#tooltip_" + random;
                $el.attr("data-tooltip-content", newId);
                $template.attr("id", newId.replace(/#/, ""));
            }
            $el.tooltipster(options);
            let instance = $el.tooltipster("instance");
            let dataVvalue = (() => {
                let data = $el.data();
                for (let i in data) {
                    if (i.match(/v-/)) {
                        return `data-${i}`;
                    }
                }
            })();
            if ($template) {
                instance.on('position', e => {
                    let $containers = $template.parents();
                    $containers.attr(dataVvalue, "");
                    let $tooltipsterArrow = $containers.last().find(".tooltipster-arrow");
                    $tooltipsterArrow.attr(dataVvalue, "");
                    $tooltipsterArrow.children().attr(dataVvalue, "");
                })
            }
            if (stop) {
                instance.on('before', e => {
                    let event = e.event.originalEvent;
                    event.stopPropagation();
                    if (single) {
                        var instances = $.tooltipster.instances();
                        instance;
                        instances.forEach(item => {
                            if (item == instance) return;
                            if (item.__state == "closed") return;
                            item.close();
                            //console.log(item.__state);
                        });
                    }
                });
                instance.on('close', e => {
                    e.stopPropagation();
                });
            }
        });
    },
    unbind(el) {
        let $el = $(el);
        let instance = $el.tooltipster("instance");
        $el.removeAttr("data-tooltip-content");
        instance.destroy();
    }
});
/**
 * [closeTooltip description] 在tooltip内部关闭tooltip
 * @param  {[type]} id [description]
 * @return {[type]}    [description]
 */
Vue.prototype.closeTooltip = function() {
    let id = $(this.$el).attr("id");
    let selector = `*[data-tooltip-content='#${id}']`;
    let $triggerPoint = $(selector);
    let instance = $triggerPoint.tooltipster("instance");
    instance.close();
};